import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider, StyleSheetManager } from "styled-components";
import { type CompareV2StateType, compareV2ClientStore } from "./redux/store";
import Globalize from "../../common-deprecated/Globalize";
import getTheme from "../../common-deprecated/themes/getTheme";
import { renderReact } from "../../common-deprecated/utils/clientRenderUtils";
import { ModalProvider } from "../../common-deprecated/containers/ModalProvider";
import { WindowDimensionsProvider } from "../../common-deprecated/containers/WindowDimensionsProvider";
import { removeLastSlashAndWhiteSpace } from "../../common-deprecated/utils";
import { shouldForwardProp } from "../../shared-logic/utils/styledComponentsUtils";

// This is a simple version of InitializeComponent, it is used to keep the bundle size small.
// Once all components have migrated to their own custom store this can be generalized.
// Props is not used for GradeExplorer, but we keep it in for backwards compatibility purposes.
export const simpleInit =
    (CompareComponent: React.ElementType) =>
    (target: string, props: unknown, initialState: CompareV2StateType): void => {
        const { commonSettings } = initialState;
        const { country, culture, currencyMultiplier } = commonSettings;

        // eslint-disable-next-line camelcase
        __webpack_public_path__ = `${removeLastSlashAndWhiteSpace(commonSettings.resourcePath)}/`;

        // Initialize store, tagging and globalize.
        const store = compareV2ClientStore(initialState, commonSettings.component);
        Globalize(country, culture, currencyMultiplier);

        renderReact(
            target,
            commonSettings,
            // Since react-redux 8, new development checks were introduced against incorrect usages of useSelector, mostly to detect unnecessary rerenders.
            // These checks were disabled for all existing components as these create quite some issues
            // Ideally these checks should be enabled in all components - UC-1220
            // Notice: Make sure to not add the 'stabilityCheck="never"' in new components
            <ReduxProvider store={store} stabilityCheck="never">
                <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                    <ThemeProvider theme={getTheme(commonSettings)}>
                        <WindowDimensionsProvider>
                            <ModalProvider>
                                <CompareComponent />
                            </ModalProvider>
                        </WindowDimensionsProvider>
                    </ThemeProvider>
                </StyleSheetManager>
            </ReduxProvider>,
        );
    };
